<template>
  <!-- 多语言切换 -->
  <div class="lang-select">
    <!-- -->
    <el-dropdown size="small ">
      <span class="el-dropdown-link">
        {{ labelShow }} <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="(item, index) in langList" :key="index" :disabled="lang === item.value"
          @click.native="changeLange(item.value)">
          {{ item.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import bus from '@/utils/eventBus.js';
import { langConfigList } from '@/utils/config.js'
export default {
  name: 'LangSelect',
  data() {
    return {
      langList: langConfigList
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang.lang
    },
    labelShow() {
      const target = this.langList.find(item => item.value === this.lang)
      if (target) {
        return target.label
      }
      return '中文'
    }
  },
  methods: {
    changeLange(lang) {
      this.$store.commit('setLang', lang);
      const target = this.langList.find(item => item.value === lang)
      if (target) {
        bus.$emit('langChanged', target.text);
      }
      this.$i18n.locale = lang;

      // 刷新页面
      window.location.reload();
    }
  },
};
</script>

<style lang="scss" scoped>
.el-dropdown-link {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/langSelect/index.vue